import { Injectable } from "@angular/core";
import { ServiceResponse } from "@appcore/data";
import { API } from "@service/system/api.service";
import { ResponseHandler } from "@service/system/responseHandler.service";
import { Observable } from "rxjs";

const API_URL = API.API_URL;

@Injectable()
export class SalesforceSyncService {
	private _serviceUrl = `${API_URL}`;

	constructor(private responseHandler: ResponseHandler) {}

	syncSalesforceAccounts(): Observable<ServiceResponse<string>> {
		return this.responseHandler.httpGet<string>(`${this._serviceUrl}/cha/salesforce/sync`);
	}

	forceRefreshToken(): Observable<ServiceResponse<string>> {
		return this.responseHandler.httpPost<string>(`${this._serviceUrl}/token/cha/request?storeToken=true`, null);
	}
}
